<p>
    <span class="d-inline-block font-weight-bold">{{(title | translate) + ': '}}</span>

    <span class="cast-align">
        <!-- Person -->
        <div class="d-inline-block" *ngFor="let person of cast; let pos = index;">
            <!-- Person with bio -->
            <div *ngIf="person.description">
                <a class="person-name cursor-po" [matMenuTriggerFor]="aboveMenu">
                    {{person.name + (pos < cast.length-1 ? ", " : "" )}} </a>
                        <mat-menu #aboveMenu="matMenu">
                            <button mat-menu-item (click)="openBio(person)">{{'gen_biography' |
                                translate}}</button>
                            <button mat-menu-item>
                                <a [href]="'#/search/' + person.name">{{'gen_search' | translate}}</a>
                            </button>
                        </mat-menu>
            </div>

            <!-- Person with no bio -->
            <div *ngIf="!person.description">
                <a class="person-name" [href]="'#/search/' + person.name">
                    {{person.name + (pos < cast.length-1 ? ", " : "" )}} </a>
            </div>
        </div>
    </span>
</p>